import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = {
  id: "kt_app_content",
  class: "app-content flex-column-fluid"
}
const _hoisted_3 = {
  id: "kt_app_content_container",
  class: "app-container container-xxl"
}
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      "data-kt-user-table-filter": "search",
      class: "form-control form-control-solid w-250px ps-14",
      placeholder: "Search user"
    })
  ])
], -1)
const _hoisted_6 = { class: "card-body py-4" }
const _hoisted_7 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "kt_table_users"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-10px pe-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid me-3" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "data-kt-check": "true",
          "data-kt-check-target": "#kt_table_users .form-check-input",
          value: "1"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Role"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Lang"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Timezone"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px text-center" }, "Two-step"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Last login"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center min-w-100px" }, "Actions")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      value: "1"
    })
  ])
], -1)
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "symbol symbol-circle symbol-50px overflow-hidden me-3" }
const _hoisted_15 = { href: "../../demo1/dist/apps/user-management/users/view.html" }
const _hoisted_16 = { class: "symbol-label" }
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = {
  href: "../../demo1/dist/apps/user-management/users/view.html",
  class: "text-gray-800 text-hover-primary mb-1"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Administrator", -1)
const _hoisted_20 = { class: "badge badge-light fw-bold" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "ON", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "09/28 10:00", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-light btn-active-light-primary btn-sm",
    "data-kt-menu-trigger": "click",
    "data-kt-menu-placement": "bottom-end"
  }, "Actions")
], -1)

import { ref, onMounted, inject } from "vue";
import ErrorMsg from "@/components/ErrorMsg";
import UserCreateView from "./UserCreate.vue";
import AuthImage from "@/components/AuthImage.vue";
import { apiProviderKey } from "@/core/plugins/providerKeys";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserIndex',
  setup(__props) {

const api = inject(apiProviderKey);
const isLoading = ref(true);
const items = ref([]);
const userCreate = ref(null);
const pagenation = ref([]);

const fetchData = () => {
  api["user.list"]()
    .then(({ data }) => {
      items.value = data.data;
      console.log("pagenation", pagenation);
      pagenation.value = data.links;
      console.log("pagenation", pagenation.value.first);
      isLoading.value = false;
    })
    .catch(({ response }) => {
      console.log(response);
      ErrorMsg.show(response);
      isLoading.value = false;
    });
  console.log("fetch data");
};

onMounted(() => {
  fetchData();
});

const createUser = () => {
  userCreate.value.show();
};

const onCreated = (data) => {
  items.value.unshift(data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", { class: "card-header border-0 pt-6" }, [
              _hoisted_5,
              _createElementVNode("div", { class: "card-toolbar" }, [
                _createElementVNode("div", {
                  class: "d-flex justify-content-end",
                  "data-kt-user-table-toolbar": "base"
                }, [
                  _createElementVNode("button", {
                    id: "user_create_toggle",
                    type: "button",
                    class: "btn btn-primary",
                    onClick: createUser
                  }, " Add User ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                      _createVNode(LoadingRing)
                    ]))
                  : (!isLoading.value && items.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                        _createVNode(NoDataBox)
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _hoisted_12,
                            _createElementVNode("td", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("a", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(AuthImage, {
                                      class: "w-100",
                                      imageGuid: item.avatar,
                                      alt: item.name
                                    }, null, 8, ["imageGuid", "alt"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("a", _hoisted_18, _toDisplayString(item.name), 1),
                                _createElementVNode("span", null, _toDisplayString(item.email), 1)
                              ])
                            ]),
                            _hoisted_19,
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(item.lang), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.timezone), 1),
                            _hoisted_21,
                            _hoisted_22,
                            _hoisted_23
                          ]))
                        }), 128))
                      ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(UserCreateView, {
      ref_key: "userCreate",
      ref: userCreate,
      onCreated: onCreated
    }, null, 512)
  ], 64))
}
}

})